module.exports = __webpack_public_path__ + "img/down-arrow.b080e448.svg";